import { ShopifyDominion } from "./shopify/ShopifyDominion";

import { BigCommerceDominion } from "./bigcommerce/BigCommerceDominion";
import { ShopifyKey } from "./utils";

export type ConnectionFieldKeySpecT = Readonly<{ key: string; name: string }>;
export type ConnectionFieldKeyFieldT = Readonly<{
  contributorConfiguration?: {
    [ShopifyDominion.id]?: {
      shopifyFieldKey?: string | null;
      graphQLFieldKey?: string | null;
    };
    [BigCommerceDominion.id]?: {
      bigcommerceFieldKey?: string | null;
    };
  };
  customApiIdentifier?: string | null;
  name: string;
  key?: string;
  includeTypeInFieldKey?: boolean;
  fieldType: string;
}>;

export const connectionFieldKey = (input: ConnectionFieldKeySpecT, field: ConnectionFieldKeyFieldT) => {
  const connectionFieldKeyFromSpec =
    field.contributorConfiguration?.[ShopifyDominion.id]?.shopifyFieldKey ??
    field.contributorConfiguration?.[ShopifyDominion.id]?.graphQLFieldKey ??
    field.contributorConfiguration?.[BigCommerceDominion.id]?.bigcommerceFieldKey ??
    field.key;

  if (connectionFieldKeyFromSpec) {
    const base = `${input.key}-${connectionFieldKeyFromSpec}`;
    if (field.includeTypeInFieldKey) {
      return `${base}-${field.fieldType}`;
    }
    return base;
  } else {
    throw new Error(`Field key for field "${input.name}.${field.customApiIdentifier ?? field.name}" is auto-generated`);
  }
};

export const connectionFieldKeyFromShopifyKey = (
  input: ConnectionFieldKeySpecT,
  field: ConnectionFieldKeyFieldT,
  fromShopifyFieldKey: ShopifyKey
) => {
  const value = field.contributorConfiguration?.[ShopifyDominion.id]?.[fromShopifyFieldKey];
  if (value) {
    const base = `${input.key}-${value}`;
    if (field.includeTypeInFieldKey) {
      return `${base}-${field.fieldType}`;
    }
    return base;
  }
  return null;
};
